/**
 * @desc 根据平台单号及平台Map查询订单明细列表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: any, options?: any) {
  return updateResponse(
    http(URL + `/rpc/oms/getOrderItemBySpOrderNoAndPlatformMapList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
